import Column from '@components/Column';
import Text from '@components/Text';
import styled from '@emotion/styled';
import useGlobalName from '@hooks/useGlobalName';
import { ItemResponse } from '@models/item';

import ItemImage from './ItemImage';
import ItemInfoActions from './ItemInfoActions';

interface Props {
    item: ItemResponse;
    shopId: string;
}

function ItemInfo({ item }:Props) {
    const {
        name, description, imageUrls, nameKo, nameJa, nameEn,
    } = item;
    const itemName = useGlobalName({
        nameKo, nameEn, nameJa, name,
    });
    return (
        <Container as='section' align='center'
            fullWidth
            spacing={3}>
            <ItemImage imageUrls={imageUrls}
                name={itemName} />
            <BreakText size='display' fontWeight='bold' align='center' >
                {itemName}
            </BreakText>
            {description && (
                <BreakText align='center' >
                    {description}
                </BreakText>
            )}
            <ItemInfoActions imageUrls={imageUrls} itemId={item.id} />
        </Container>
    );
}

const Container = styled(Column)`
    padding: var(--spacing-8) var(--spacing-5) var(--spacing-4);
    position: relative;
`;

const BreakText = styled(Text)`
    word-break: break-word;
`;

export default ItemInfo;
